export default {
  // НЭП
  DSS: 'DSS',
  // НЭП VipNet LSS
  ITEX: 'VIPNET',
  // КЭП
  QES: 'QES',
};
